import { useMemo } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import { Bar } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { useSelector } from 'react-redux'

import GraphContainer from '../../GraphContainer'
import { hasChartData } from '../helpers/chartDataHelpers'

import { useSroiFilters } from '../../../SroiFiltersContext'
import { generateSocialValueByAgeGroupData } from './socialValueByAgeGroupHelpers'
import { getOptions } from '../../getOptions'
import { useSroiReportCurrencySymbol } from '../../../hooks'

import { socialReturnOnInvestmentReportSelector } from '../../../../../../modules/selectors/socialReturnOnInvestment'

import { gridCharts, helpTexts } from '../../../constants'

const SocialValueByAgeGroup = () => {
  const { t } = useTranslation()
  const { selectedRegion, selectedStakeholder } = useSroiFilters()

  const report = useSelector(socialReturnOnInvestmentReportSelector)
  const currencySymbol = useSroiReportCurrencySymbol()

  const graphData = useMemo(() => {
    return generateSocialValueByAgeGroupData({
      selectedRegion,
      selectedStakeholder,
      report
    })
  }, [selectedRegion, selectedStakeholder, report])

  const legendContainerId = useMemo(() => uuidv4(), [])

  const options = useMemo(
    () =>
      getOptions({
        legendContainerId,
        datasets: graphData?.datasets || [],
        currencySymbol,
        showYAxisLabels: true,
        hideLegend: true
      }),
    [legendContainerId, graphData, currencySymbol]
  )

  const plugins = useMemo(() => {
    return [ChartDataLabels]
  }, [])

  // Don't render chart if there's no data
  if (!hasChartData(graphData)) {
    return null
  }

  return (
    <GraphContainer
      id={gridCharts.sroiSocialValueAge}
      title={t('Impact by Age Group')}
      helpText={helpTexts.impactByAgeGroup}
    >
      <Bar type="bar" data={graphData} options={options} plugins={plugins} />
    </GraphContainer>
  )
}

export default SocialValueByAgeGroup
